import React, { useEffect, useState } from "react";
import '../Styles/OnboardingPopup.css';

const OnboardingPopups = () => {
  const [step, setStep] = useState(0); // 0 = none, 1 = profile, 2 = event
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 🔹 Fetch logged in user
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const users = JSON.parse(localStorage.getItem("users")) || [];
  
    if (loggedIn && users.length > 0) {
      const matchedUser = users.find(
        (u) =>
          (u.userId === loggedIn.login ||
            u.email === loggedIn.login ||
            u.mobile === loggedIn.login) &&
          u.password === loggedIn.password
      );
  
      if (matchedUser) {
        // 🔹 Check firstTimeLogin
        const isFirstLogin = matchedUser.firstTimeLogin === true;
        if (isFirstLogin) {
          setStep(1);
          setVisible(true);
        }
      }
    }
  }, []);
  
  useEffect(() => {
    let timer;
    if (visible) {
      timer = setTimeout(() => {
        if (step === 1) {
          setStep(2);
          setVisible(true);
        } else if (step === 2) {
          setStep(3);
          setVisible(true);
        } else if (step === 3) {
          setStep(4);
          setVisible(true);
        } else if (step === 4) {
          setStep(5);
          setVisible(true);
        } else if (step === 5) {
          // 🔹 Steps completed → update user in storage
          const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
          const users = JSON.parse(localStorage.getItem("users")) || [];
  
          if (loggedIn && users.length > 0) {
            const matchedUserIndex = users.findIndex(
              (u) =>
                (u.userId === loggedIn.login ||
                  u.email === loggedIn.login ||
                  u.mobile === loggedIn.login) &&
                u.password === loggedIn.password
            );
  
            if (matchedUserIndex !== -1) {
              users[matchedUserIndex].firstTimeLogin = false; // ✅ mark complete
              localStorage.setItem("users", JSON.stringify(users));
            }
          }
  
          setVisible(false);
        }
      }, 5000); // ⏳ 5s per step (change if needed)
    }
    return () => clearTimeout(timer);
  }, [step, visible]);
  

  if (!visible) return null;

  return (
    <>
      {step === 1 && (
        <div className="onboarding-popup profile-popup" style={{marginTop: 450}}>
            <p> Profile</p>
          <p>Create your profile based on your passion or interest.</p>
        </div>
      )}
      {step === 2 && (
        <div className="onboarding-popup event-popup" style={{marginTop: 500, marginLeft: -150}}>
          <p>Create your event profile. You can post content on your events securely.</p>
        </div>
      )}
      {step === 3 && (
        <div className="onboarding-popup event-popup" style={{marginTop: 500, marginLeft: 700}}>
          <p> Klamity </p>
          <p>Update about climatic Disasters and weather predictions. </p>
        </div>
      )}
      {step === 4 && (
        <div className="onboarding-popup event-popup" style={{marginTop: -200, marginLeft: 1000}}>
          <p> Settings </p>
          <p>Customize your page with per profile options. </p>
        </div>
      )}
      {step === 5 && (
        <div className="onboarding-popup event-popup" style={{marginTop: -200, marginLeft: 300}}>
          <p> Trends </p>
          <p> Check the profiles which currently on trends. </p>
        </div>
      )}
    </>
  );
};

export default OnboardingPopups;
